module.exports = __webpack_public_path__ + "img/Restaurant13.cc64af6d.png";